import React from "react";
import { Box } from "@mui/material";
import HeroBanner from "./HeroBanner";
import KeyBenefits from "./KeyBenefits";
import WholesaleCustomers from "./WholesaleCustomers";
import HowItWorks from "./HowItWorks";
import ReadyToTrade from "./ReadyToTrade";

const DesktopTrade = ({ bannerUrl, benefits, customers, steps, onNewTrade, onExistingTrade }) => (
  <Box>
    <HeroBanner bannerUrl={bannerUrl} onNewTrade={onNewTrade} onExistingTrade={onExistingTrade} />
    <KeyBenefits benefits={benefits} />
    <ReadyToTrade onNewTrade={onNewTrade} onExistingTrade={onExistingTrade} />
    <HowItWorks steps={steps} />
    <WholesaleCustomers customers={customers} />
  </Box>
);

export default DesktopTrade;
